import { clone } from '@/common/js/just.js'

/**
 * @description: 打开修改计划出价弹窗
 * @param {*} rowIndex // 单条修改时的行索引
 * @return {*}
 */
export function onBidModify(rowIndex) {
  // 点击单行时设置check状态
  if (!Object.is(Number(rowIndex), NaN)) {
    this.tableData = this.tableData.map((row, index) => {
      if (index === rowIndex) {
        return { ...row, bidCheck: true }
      }
      return row
    })
  } else {
    if (!this.tableData.some((row) => row.bidCheck)) {
      return this.$Message.warning('请选择修改行')
    }
  }

  // 保存当前需要更改的行，如果是全选更改，那么保存第一个
  this.currentModifyTableRow = clone(this.tableData[rowIndex || 0])

  this.modal.showGlobalBidModify = true
}

/**
 * @description: 更换账号确认
 * @return {*}
 */
export function onBidModifyConfirm(bidForm) {
  this.tableData = this.tableData.map((row) => {
    if (row.bidCheck) {
      const newRow = clone(row)
      newRow.bid = { ...newRow.bid, ...bidForm }
      return newRow
    }

    return row
  })
  this.onModifyModalCancel()
}
